const GerenciadorDados = () => (
  <div className="gerenciador-dados">
    <div className="gerenciador-dados-text">
      <h2>Gerenciador de dados</h2>
      <p>
        Use o menu à esquerda para navegar nas seções disponíveis e gerenciar os
        dados da sua aplicação.
      </p>
    </div>
  </div>
);

export default GerenciadorDados;
